import { useMemo } from "react";

import { BASE_WELL_LAYER } from "constants/mapLayers.constants";
import { selectLayerStyleSettings, useMapStore } from "stores/map";
import styled from "styled-components";

import ColorPicker from "components/base/ColorPicker";
import { BASE_WELL_GRAY } from "components/map/utils/baseWellGlyphs";
import { resolveBaseWellStyle } from "components/map/utils/baseWellStyle";
import { useUpdateLayerStyle } from "components/project/layers/hooks";

const DEFAULT_SWATCH = { color: BASE_WELL_GRAY, label: "Default" };

export function BaseWellColorPicker() {
  const layerStyleSettings = useMapStore(selectLayerStyleSettings);
  const { updateLayerStyle } = useUpdateLayerStyle();

  const { color, opacity, thickness } = resolveBaseWellStyle(
    layerStyleSettings[BASE_WELL_LAYER]
  );

  // A fresh `values` object every render would re-fire ColorPicker's identity-keyed setValues effect.
  const values = useMemo(
    () => ({ color, strokeColor: color, thickness, opacity: opacity * 100 }),
    [color, opacity, thickness]
  );

  return (
    <SwatchWrapper>
      <ColorPicker
        hasOutline={false}
        includeOpacity
        includeFillThickness
        disableTransparent
        pinnedColor={DEFAULT_SWATCH}
        values={values}
        onChange={(_, value) => updateLayerStyle(BASE_WELL_LAYER, { color: value })}
        onChangeOpacity={(_, value) =>
          updateLayerStyle(BASE_WELL_LAYER, { opacity: value })
        }
        onChangeThickness={(_, value) =>
          updateLayerStyle(BASE_WELL_LAYER, { thickness: value })
        }
      />
    </SwatchWrapper>
  );
}

// ProjectActivity nudges every .ColorPicker down 4px; centre this one on the row label instead.
const SwatchWrapper = styled.span`
  display: inline-flex;

  && .ColorPicker {
    top: 0;
  }
`;
